import React from 'react';
import TagGroupList from '../TagGroupList';
import TagGroupListSearchBox from '../TagGroupListSearchBox';

const TagGroupListWrap = (props) => {
  const { tagGroupList, setData, getList } = props;

  return (
    <div className="tag-group-list-wrap">
      {/* 태그 그룹 검색 박스*/}
      <TagGroupListSearchBox
        setData={(data) =>
          setData({
            path: ['tagGroupList', 'searchData', ...data.path],
            value: data.value,
          })
        }
        searchData={tagGroupList.searchData}
        getList={getList}
      />

      {/* 태그 그룹 리스트*/}
      <TagGroupList
        tagList={tagGroupList.list}
        sortOption={tagGroupList.sortOption}
        pagination={tagGroupList.pagination}
        getList={getList}
      />
    </div>
  );
};

export default TagGroupListWrap;
